export * as PrimProductCard from "./product-card";
